import { createAction, props } from '@ngrx/store';
import { MappedHttpErrorResponse } from '@adnova/jf-ng-components';
import { AnnouncementDTO, AnnouncementSettingsDTO, ProblemDTO } from '../../openapi/shell-service-openapi';

/**
 * Actions für die Endnutzer-Announcements.
 */
export class UserAnnouncementEntitiesActions {
  private static readonly prefix = '[User Announcement Entities]';

  /** Lädt die aktuell aktiven, ungelesenen Announcements. */
  static loadCurrent = createAction(
    `${this.prefix} Load Current`,
  );

  /** Announcements erfolgreich geladen. */
  static loadCurrentSuccess = createAction(
    `${this.prefix} Load Current Success`,
    props<{ announcements: AnnouncementDTO[]; unreadCount?: number }>(),
  );

  /** Fehler beim Laden der Announcements. */
  static loadCurrentFailure = createAction(
    `${this.prefix} Load Current Failure`,
    props<{ error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Markiert ein Announcement als gelesen. */
  static markRead = createAction(
    `${this.prefix} Mark Read`,
    props<{ id: string }>(),
  );

  /** Announcement erfolgreich als gelesen markiert. */
  static markReadSuccess = createAction(
    `${this.prefix} Mark Read Success`,
    props<{ id: string }>(),
  );

  /** Fehler beim Markieren als gelesen. */
  static markReadFailure = createAction(
    `${this.prefix} Mark Read Failure`,
    props<{ id: string; error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Lädt ein Announcement-Bild. */
  static loadImage = createAction(
    `${this.prefix} Load Image`,
    props<{ imageId: string }>(),
  );

  /** Bild erfolgreich geladen. */
  static loadImageSuccess = createAction(
    `${this.prefix} Load Image Success`,
    props<{ imageId: string; blobUrl: string }>(),
  );

  /** Fehler beim Laden des Bildes. */
  static loadImageFailure = createAction(
    `${this.prefix} Load Image Failure`,
    props<{ imageId: string; error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Navigiert zum nächsten oder vorherigen Eintrag. */
  static navigate = createAction(
    `${this.prefix} Navigate`,
    props<{ direction: 'next' | 'prev'; currentId?: string }>(),
  );

  /** Lädt die Announcement-Settings. */
  static loadSettings = createAction(
    `${this.prefix} Load Settings`,
  );

  /** Settings erfolgreich geladen. */
  static loadSettingsSuccess = createAction(
    `${this.prefix} Load Settings Success`,
    props<{ enabled: boolean }>(),
  );

  /** Fehler beim Laden der Settings. */
  static loadSettingsFailure = createAction(
    `${this.prefix} Load Settings Failure`,
    props<{ error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Aktualisiert die Announcement-Settings (sofort bei Checkbox-Change). */
  static updateSettings = createAction(
    `${this.prefix} Update Settings`,
    props<{ enabled: boolean }>(),
  );

  /** Settings erfolgreich aktualisiert. */
  static updateSettingsSuccess = createAction(
    `${this.prefix} Update Settings Success`,
    props<{ enabled: boolean }>(),
  );

  /** Fehler beim Aktualisieren der Settings. */
  static updateSettingsFailure = createAction(
    `${this.prefix} Update Settings Failure`,
    props<{ previousEnabled: boolean; error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Markiert alle Announcements als gelesen (Archiv-Seite öffnen). */
  static markAllRead = createAction(
    `${this.prefix} Mark All Read`,
  );

  /** Alle Announcements erfolgreich als gelesen markiert. */
  static markAllReadSuccess = createAction(
    `${this.prefix} Mark All Read Success`,
  );

  /** Fehler beim Markieren aller Announcements als gelesen. */
  static markAllReadFailure = createAction(
    `${this.prefix} Mark All Read Failure`,
    props<{ error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Setzt den State auf den Initialzustand zurück. */
  static reset = createAction(
    `${this.prefix} Reset`,
  );
}
